/* Next dispatch countdown. All time math anchored to Europe/Oslo regardless of
   visitor timezone. Config arrives as escaped JSON on [data-bc-dispatch-config];
   visibility follows data-bc-dispatch-stock-ok or [data-bc-pdp-stock] green. */
(function () {
  'use strict';

  var SOON_MS = 86400000;

  var DTF = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Oslo',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  });

  function osloParts(epochMs) {
    var p = {};
    DTF.formatToParts(epochMs).forEach(function (part) { p[part.type] = part.value; });
    return { y: +p.year, m: +p.month, d: +p.day, hh: (+p.hour) % 24, mm: +p.minute, ss: +p.second };
  }

  function osloWallToEpoch(y, m, d, hh, mm) {
    var target = Date.UTC(y, m - 1, d, hh, mm, 0);
    var guess = target;
    for (var i = 0; i < 2; i++) {
      var w = osloParts(guess);
      guess += target - Date.UTC(w.y, w.m - 1, w.d, w.hh, w.mm, w.ss);
    }
    return guess;
  }

  function dayKey(c) {
    return c.y + '-' + String(c.m).padStart(2, '0') + '-' + String(c.d).padStart(2, '0');
  }
  function weekdayOf(c) { return new Date(Date.UTC(c.y, c.m - 1, c.d)).getUTCDay(); }
  function addDays(c, n) {
    var t = new Date(Date.UTC(c.y, c.m - 1, c.d + n));
    return { y: t.getUTCFullYear(), m: t.getUTCMonth() + 1, d: t.getUTCDate() };
  }
  function sameDay(a, b) { return a.y === b.y && a.m === b.m && a.d === b.d; }

  function isDispatchDay(cfg, c) {
    return cfg.days[weekdayOf(c)] === true && !cfg.holidaySet[dayKey(c)];
  }

  function compute(cfg, nowMs) {
    var now = osloParts(nowMs);
    var today = { y: now.y, m: now.m, d: now.d };

    var day = today, cutoffEpoch = null, i;
    for (i = 0; i < 370; i++) {
      if (isDispatchDay(cfg, day)) {
        var e = osloWallToEpoch(day.y, day.m, day.d, cfg.cutoffH, cfg.cutoffM);
        if (e > nowMs) { cutoffEpoch = e; break; }
      }
      day = addDays(day, 1);
    }
    if (cutoffEpoch === null) return null;

    var dispatchDay = day, steps = cfg.leadDays, guard = 0;
    while (steps > 0 && guard++ < 500) {
      dispatchDay = addDays(dispatchDay, 1);
      if (isDispatchDay(cfg, dispatchDay)) steps--;
    }
    if (steps > 0) return null;

    return {
      cutoffEpoch: cutoffEpoch,
      dispatchDay: dispatchDay,
      isToday: sameDay(dispatchDay, today),
      isTomorrow: sameDay(dispatchDay, addDays(today, 1)),
      remainingMs: cutoffEpoch - nowMs
    };
  }

  function resolveMode(r) {
    if (!r) return null;
    if (r.isToday) return 'today';
    if (r.remainingMs <= SOON_MS) return 'soon';
    return 'later';
  }

  function parseConfig(el) {
    var cfg;
    try { cfg = JSON.parse(el.getAttribute('data-bc-dispatch-config')); }
    catch (_) { return null; }
    if (!cfg || !/^([01]?\d|2[0-3]):[0-5]\d$/.test(cfg.cutoff || '')) return null;
    if (!Array.isArray(cfg.days) || cfg.days.length !== 7 || cfg.days.indexOf(true) === -1) return null;
    var hm = cfg.cutoff.split(':');
    cfg.cutoffH = +hm[0]; cfg.cutoffM = +hm[1];
    cfg.holidaySet = {};
    String(cfg.holidays || '').split(/\r?\n/).forEach(function (line) {
      var s = line.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) cfg.holidaySet[s] = true;
    });
    cfg.leadDays = Math.min(60, Math.max(0, parseInt(cfg.leadDays, 10) || 0));
    return cfg;
  }

  function formatRemaining(cfg, ms) {
    var totalMin = Math.max(1, Math.ceil(ms / 60000));
    var h = Math.floor(totalMin / 60), min = totalMin % 60;
    if (h > 0) return h + ' ' + cfg.i18n.hoursAbbr + ' ' + min + ' ' + cfg.i18n.minutesAbbr;
    return min + ' ' + cfg.i18n.minutesAbbr;
  }

  function ariaTimeLabel(cfg, ms) {
    var totalMin = Math.max(1, Math.ceil(ms / 60000));
    var h = Math.floor(totalMin / 60), min = totalMin % 60;
    var parts = [];
    if (h > 0) parts.push(h + ' ' + cfg.i18n.hoursAbbr);
    parts.push(min + ' ' + cfg.i18n.minutesAbbr);
    return parts.join(' ');
  }

  var weekdayFmt = null;
  function dayLabel(cfg, r) {
    if (r.isToday) return cfg.i18n.today;
    if (r.isTomorrow) return cfg.i18n.tomorrow;
    if (!weekdayFmt) {
      weekdayFmt = new Intl.DateTimeFormat(document.documentElement.lang || 'nb',
        { weekday: 'long', timeZone: 'UTC' });
    }
    return weekdayFmt.format(Date.UTC(r.dispatchDay.y, r.dispatchDay.m - 1, r.dispatchDay.d, 12));
  }

  function templateForMode(cfg, mode) {
    if (mode === 'today') return cfg.i18n.orderWithin;
    if (mode === 'soon') return cfg.i18n.orderForDay;
    return cfg.i18n.nextDispatch;
  }

  function buildMessage(cfg, r, mode, textEl) {
    var tpl = templateForMode(cfg, mode);
    textEl.textContent = '';
    var parts = tpl.split(mode !== 'later' ? /(%time%|%day%)/ : /(%day%)/);
    var i, part;
    for (i = 0; i < parts.length; i++) {
      part = parts[i];
      if (part === '%time%') {
        var t = document.createElement('span');
        t.className = 'bc-dispatch__timer';
        t.setAttribute('role', 'timer');
        t.setAttribute('aria-label', ariaTimeLabel(cfg, r.remainingMs));
        t.textContent = formatRemaining(cfg, r.remainingMs);
        textEl.appendChild(t);
      } else if (part === '%day%') {
        var d = document.createElement('strong');
        d.textContent = dayLabel(cfg, r);
        textEl.appendChild(d);
      } else if (part) {
        textEl.appendChild(document.createTextNode(part));
      }
    }
  }

  function render(cfg, el, textEl, fallbackEl, nowMs) {
    var r = compute(cfg, nowMs);
    if (!r) { el.hidden = true; return; }

    var stockOk = el.getAttribute('data-bc-dispatch-stock-ok') === 'true';
    if (!stockOk) {
      var stock = el.parentElement && el.parentElement.querySelector('[data-bc-pdp-stock]');
      if (stock) stockOk = stock.getAttribute('data-stock-state') === 'green';
    }
    if (!stockOk) { el.hidden = true; return; }

    var mode = resolveMode(r);
    el.setAttribute('data-bc-dispatch-mode', mode);
    buildMessage(cfg, r, mode, textEl);

    if (fallbackEl) {
      if (mode === 'later' && cfg.i18n.fallbackAfterCutoff) {
        fallbackEl.textContent = cfg.i18n.fallbackAfterCutoff.replace('%cutoff%', cfg.cutoff || '');
        fallbackEl.hidden = false;
      } else {
        fallbackEl.textContent = '';
        fallbackEl.hidden = true;
      }
    }

    el.hidden = false;
  }

  function init(el) {
    var cfg = parseConfig(el);
    var textEl = el.querySelector('[data-bc-dispatch-text]');
    var fallbackEl = el.querySelector('[data-bc-dispatch-fallback]');
    if (!cfg || !textEl) { el.hidden = true; return; }

    var nowFn = function () {
      return window.bcDispatchNowOverride ? window.bcDispatchNowOverride() : Date.now();
    };

    if (el._bcDispatchTimer) clearTimeout(el._bcDispatchTimer);
    function tick() {
      render(cfg, el, textEl, fallbackEl, nowFn());
      var delay = 60000 - (nowFn() % 60000) + 250;
      el._bcDispatchTimer = setTimeout(tick, delay);
    }
    tick();

    if (el._bcDispatchInited) return;
    el._bcDispatchInited = true;

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) render(cfg, el, textEl, fallbackEl, nowFn());
    });

    var stock = (el.parentElement && el.parentElement.querySelector('[data-bc-pdp-stock]'))
      || document.querySelector('[data-bc-pdp-stock]');
    if (stock) {
      new MutationObserver(function () {
        render(cfg, el, textEl, fallbackEl, nowFn());
      }).observe(stock, { attributes: true, attributeFilter: ['data-stock-state'] });
    }
  }

  function boot() {
    document.querySelectorAll('[data-bc-dispatch]').forEach(init);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  }

  globalThis.bcDispatch = {
    compute: compute,
    osloWallToEpoch: osloWallToEpoch,
    osloParts: osloParts,
    parseConfig: parseConfig,
    resolveMode: resolveMode,
    boot: boot
  };
})();
